exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3PYB96jq5FIbDbQgz1N9DT{background:#f5f5f5;padding:20px 0 20px 0}\n", ""]);

// Exports
exports.locals = {
	"Stats": "_3PYB96jq5FIbDbQgz1N9DT"
};